export default "__VITE_ASSET__C6E_YF26__";